export default class FreedomAPI {
    static get http() { return 'graphql' }
    static get headers() { return {'Content-Type': 'application/json'} }

    static async query(query, name) { return await this._call('query', query, name) }
    static async mutation(query, name) { return await this._call('mutation', query, name) }

    /**
     * Call API with a given query
     * @param type - "query" || "mutation"
     * @param query - String || Object
     * @param name - query name (if set, will return the rsp.data[name] value instead of entire response (does not work with query object)
     * @returns {Promise<Object>}
     */
    static async _call(type, query, name) {
        const queryString = this._prepareQueryString(type, query);
        const body = JSON.stringify({query: queryString});
        return fetch(this.http, {method: 'POST', headers: this.headers, body: body})
            .then(res => res.json())
            .then(rsp => name ? rsp.data[name] : rsp)
            .catch(() => console.log(`${type} Error`));
    }

    /**
     *
     * @param type - "query" || "mutation"
     * @param query - String || Object
     * @returns {string}
     * @private
     */
    static _prepareQueryString(type, query) {
        let queryString = '';
        if (typeof(query) === 'object') {
            queryString = `${type} { `;
            Object.keys(query).forEach(alias => queryString += ` ${alias}: ${query[alias]}`);
            queryString += ` }`;
        } else {
            queryString = `${type} { ${query} }`
        }
        return queryString;
    }

    /**
     * Returns a simple get GraphQL query string
     * @param name - Query name
     * @param fields - Array of fields to return
     * @param params - Key:value object -- Values MUST be exactly as necessary. Ex: `"im a string"`, (if it needs " around it, put it around it in the value, etc)
     * @param pageSize - How big of a page to grab (default to 25)
     * @returns {string}
     */
    static buildQuery(name, fields = [], params = {}, pageSize = 25, page = 1) {
        fields = fields.join(' ');
        if (pageSize) params['first'] = pageSize;
        if (page) params['page'] = page;
        const paramNames = Object.keys(params);
        let queryParams = '';
        if (paramNames.length > 0) {
            queryParams += `(`;
            paramNames.forEach(name => queryParams += `${name}: ${params[name]},`);
            queryParams = queryParams.slice(0, -1); // Remove last unnecessary comma
            queryParams += `)`;
        }

        return (pageSize)
            ? `${name} ${queryParams} { data { ${fields} } paginatorInfo { total count currentPage } }` // Use data attribute. this has pages
            : `${name} ${queryParams} { ${fields} }` ; // Dont use data attribute, NOT a paginated query
    }

}